<template>
  <div>
    <delegation-rate-menu></delegation-rate-menu>

    <h2>
      {{ $t("settings.delegationRate.standardDelegationRate.title") }}
    </h2>

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
      </v-col>
      <v-spacer />
      <div>
        <v-btn @click="reset" block color="primary">{{ $t("settings.delegationRate.standardDelegationRate.revertStatutoryRates") }}</v-btn>
      </div>
      <div>
        <DelegationRateFormDialog @saved="loadList">
          <v-btn block color="accent">{{ $t("settings.delegationRate.standardDelegationRate.addNewRate") }}</v-btn>
        </DelegationRateFormDialog>
      </div>
    </v-row>

    <v-data-table :headers="headers" :items="delegationRate" :search="search" :custom-filter="filterOverAllProperty" sort-by="country_symbol">
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ getCountryTranslatedName(props.item.country_symbol) }}
          </td>
          <td class="text-left">{{ props.item.region }}</td>
          <td class="text-left">{{ props.item.amount }} {{ props.item.currency }}</td>
          <td class="text-left">{{ props.item.hotel_limit }} {{ props.item.currency }}</td>
          <td class="text-center text-no-wrap">
            <DelegationRateFormDialog :id="props.item.id" @saved="loadList"> </DelegationRateFormDialog>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn @click.native="remove(props.item)" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DelegationRateMenu from "../../../components/Settings/DelegationRate/DelegationRateMenu.vue";
import { getTranslatedCountryName } from "../../../staticData/CountryTypes";

import DelegationRateFormDialog from "../../../components/Settings/DelegationRate/DelegationRateFormDialog.vue";
import filterOverAllProperty from "../../../repository/filterOverAllProperty";

export default {
  name: "SettingsDelegationRateView",
  components: { DelegationRateFormDialog, DelegationRateMenu },
  data: () => ({
    delegationRate: [],
    search: null
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("global.country"), value: "country_symbol" },
        { text: this.$t("global.region"), value: "region" },
        { text: this.$t("global.diet"), value: "amount" },
        { text: this.$t("global.hotelLimit"), value: "hotel_limit" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {
    filterOverAllProperty: filterOverAllProperty,
    getCountryTranslatedName: getTranslatedCountryName,
    loadList() {
      this.axios.get("settings/delegation-rate/get-delegation-rate").then(resp => {
        this.delegationRate = resp.data;
        for (let index in this.delegationRate) {
          this.delegationRate[index].countryNamePolish = this.getCountryTranslatedName(this.delegationRate[index].country_symbol, "PL");
          this.delegationRate[index].countryNameEnglish = this.getCountryTranslatedName(this.delegationRate[index].country_symbol, "EN");
        }
      });
    },
    reset() {
      let dialog1 = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.delegationRate.standardDelegationRate.revertStatutoryRateDialog.content"),
        title: this.$t("settings.delegationRate.standardDelegationRate.revertStatutoryRateDialog.title")
      });

      // let dialog2 = this.$store.dispatch('confirmDialog', { //TODO drugi komunikat z potwierdzeniem?
      //     content: "Operacja jest trwała i nieodwracalna, czy na pewno chcesz ją wykonać?",
      //     title: "Zresetować stawki?"
      // });

      dialog1.then(() => {
        // dialog2.then(()=>{
        this.axios.get("settings/delegation-rate/reset-to-defaults").then(() => {
          this.loadList();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("settings.delegationRate.standardDelegationRate.revertStatutoryRateDialog.snackbar"),
            position: "down"
          });
        });
        // });
      });
    },
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.content"),
        title: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.title")
      });
      dialog.then(() => {
        this.axios
          .post("settings/delegation-rate/delete-delegation-rate-item", {
            id: item.id
          })
          .then(() => {
            this.loadList();
            this.$store.dispatch("snackbarPush", {
              text: this.$t("settings.delegationRate.standardDelegationRate.removeDelegationRateDialog.snackbar"),
              position: "down"
            });
          });
      });
    }
  },
  created() {
    this.loadList();

    this.$on("saved", () => {
      this.loadList();
    });
  }
};
</script>

<style scoped></style>
